import store from "../../../store";
import pwa_news_groups from "../../catalog/news/groups/pwa_news_groups.vue";
import pwa_news_list from "../../catalog/news/list/pwa_news_list.vue";

window.pwa_news =  new Vue({
    store,
    el: 'div#pwa_news',

    name : "pwa_news",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_news_groups,
        pwa_news_list
    }
});
